import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "resource-scroll-area iodine-scrollable-y"
}
const _hoisted_2 = { class: "suggested-drg-title iodine-padding-bottom-xl" }
const _hoisted_3 = { class: "iodine-padding-top-lg iodine-padding-bottom-xl full-width" }

import { useResourcesStore } from 'src/stores/resourcesStore';
  import SuggestedDrgPane from 'components/resources/SuggestedDrgPane.vue';
  import SuggestedDrgRequirement from 'components/resources/SuggestedDrgRequirement.vue';
  import {storeToRefs} from 'pinia';
  import _ from 'lodash';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AnalysisPane',
  setup(__props) {

  const {analysisData} = storeToRefs(useResourcesStore());

return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!

  return (_unref(analysisData))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, " Suggested DRGs for " + _toDisplayString(_unref(analysisData).initialDrg), 1),
        _withDirectives(_createElementVNode("div", null, " There are no likely alternatives to your current DRG ", 512), [
          [_vShow, _unref(analysisData).suggestions === undefined || _unref(analysisData).suggestions.length === 0]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(analysisData).suggestions, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "suggested-drg",
            key: index
          }, [
            _createVNode(SuggestedDrgPane, {
              "suggested-drg-data-model": item.drg
            }, null, 8, ["suggested-drg-data-model"]),
            _createVNode(SuggestedDrgRequirement, {
              "suggested-drg-requirement-data-model": item.requirements
            }, null, 8, ["suggested-drg-requirement-data-model"]),
            _withDirectives(_createElementVNode("div", _hoisted_3, [
              _createVNode(_component_q_separator)
            ], 512), [
              [_vShow, index < _unref(_).defaultTo(_unref(analysisData).suggestions, []).length - 1]
            ])
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})